export default {
  "action": "操作",
  "all": "全部",
  "allAssetHoldings": "總持倉量",
  "apiSpotTradingVolume": "API 現貨交易量",
  "apply": "申請",
  "assetHoldingCalcQualification": "要判斷我有資格獲得 2 張還是 3 張抽獎券，資產持倉量要求是如何計算的？",
  "assets": "資產",
  "assetSnapshotRecord": "資產快照期間，您資金賬戶、現貨賬戶及合約賬戶（或統一交易賬戶和反向合約賬戶）中的所有資產將透過每小時快照記錄。",
  "available": "剩餘",
  "avgCryptoAssetInSnapshotPeriod": "{x} 天快照期間，所有加密貨幣的日均資產持倉量將透過每日快照記錄。",
  "avgDailyAndFinalHoldingsInfo": "日均持倉量將根據您的錢包餘額每小時快照計算得出。最終平均持倉量為您每日錢包餘額的平均值。",
  "avgDailyHoldingsSnapshotPeriod": "{x} 天快照期間，以下賬戶的日均持倉量將透過每小時快照記錄。",
  "avgPledgeAmountBetweenTimeRangeUtc": "{time1} – {time2} (UTC) 期間，日均持倉量至少達到 {minPledgeAmount} {currency}",
  "balance": "可用餘額",
  "botValidateErrCode101": "最小價格太低",
  "botValidateErrCode102": "最小價格太高",
  "botValidateErrCode103": "最大價格太低",
  "botValidateErrCode104": "最大價格太高",
  "botValidateErrCode105": "網格數太少",
  "botValidateErrCode106": "網格數太多",
  "botValidateErrCode107": "投資額太低，未滿足投資要求。",
  "botValidateErrCode108": "投資額太高，大於合約投資上限。",
  "botValidateErrCode109": "止盈價太低",
  "botValidateErrCode110": "止盈價太高",
  "botValidateErrCode111": "止損價太低",
  "botValidateErrCode112": "止損價太高",
  "botValidateErrCode113": "入場價太低",
  "botValidateErrCode114": "入場價太高",
  "buyDepositAdditionalAmount": "您需要追加買入/儲值<b>{additional_amount} {currency}</b>，才符合申購參與資格。所顯示的MNT僅為您主帳戶中目前所持有的資產（資金帳戶， 現貨帳戶與衍生品帳戶/ 統一交易帳戶與反向衍生品帳戶）， 不包含子帳戶中的資產與質押於Bybit儲蓄中的資產。具體的快照邏輯請參考下面的詳細說明。",
  "buyDepositAdditionalAmountBeforeTimeUtc": "您需要在 {time} (UTC) 前追加買入/儲值 <b>{additional_amount} MNT</b>。",
  "buyDepositAdditionalCurrencyForSubscription": "您需要追加買入/儲值更多 {currency} （<a href=\"{url}\" target=\"_blank\">看看還需要多少</a>），才符合申購參與資格。",
  "buyDepositForLotteryTip": "您需要追加買入/儲值更多 {currency} （<a href=\"{url}\" target=\"_blank\">看看還需要多少</a>），才符合抽獎參與資格。",
  "buyMore": "再買一筆",
  "buyMoreForHigherAllocation": "追加買入 {currency}，獲得更高項目代幣分配額度。",
  "calendar": "日曆",
  "cancel": "取消",
  "cancelAll": "撤銷全部",
  "cancelBak": "取消",
  "cancelOrder": "撤單",
  "checkSnapshotResult": "查看快照結果",
  "chooseOne": "（二選一）",
  "clickToJoinSale": "跟我一起參與 Bybit 上的 {token} Launchpad 代幣發售！敬請點擊此處：",
  "close": "關閉",
  "commitSubscriptionReminder": "恭喜！您符合認購資格。繼續持有您的資產直到快照期結束，然後在認購期間內返回此頁面，以投入您的MNT代幣。",
  "commitTokenSale": "投入 MNT 或 USDT，參與 {token} Launchpad 代幣發售！",
  "confirm": "確認",
  "contract_account": "合約賬戶",
  "copyFailed": "複製失敗",
  "copySuccessFully": "複製成功",
  "createErrorCode400": "用戶發送的數據包含非法參數。有關更多信息，請查看錯誤消息和錯誤詳情。",
  "createErrorCode401": "餘額不足。",
  "createErrorCode402": "用戶創建的機器人數量已達上限。",
  "createErrorCode403": "服務禁用",
  "createErrorCode404": "所請求資源未找到。",
  "createErrorCode407": "該用戶類型不支持創建機器人子賬戶。",
  "createErrorCode408": "選擇了重複定投標的",
  "createErrorCode409": "最大投資額無效",
  "createErrorCode410": "最大投資額無效",
  "createErrorCode411": "機器人已被關閉",
  "createErrorCode412": "統一保證金賬戶升級中",
  "createErrorCode500": "服務器內部錯誤",
  "createErrorCode501": "內部處理超時",
  "createErrorCode503": "當前定投機器人無法關閉，可能正在進行定投買入。",
  "currency": "幣種",
  "currentOperationFailed": "操作失敗，請重試。",
  "deposit": "充值",
  "depositAdditionalUsdtBeforeTimeUtc": "您需要在 {time} (UTC) 前追加儲值 <b>{additional_amount} USDT</b>。",
  "depositLotteryInfoUpdate": "如果您已按建議追加儲值 {currency}，且未提幣或兌換為其他代幣，則符合抽獎參與資格，無需再次儲值。您的最終日均持倉量將於 {time} 3:30 (UTC) 更新。",
  "derivativesAccount": "合約賬戶",
  "derivativesTrading": "衍生品交易",
  "detail": "詳情",
  "details": "詳情",
  "dialog_confirm_btn": "好的",
  "direction": "方向",
  "earnLotteryTicketsInfo": "根據您報名參與抽獎後的 VIP 等級、現貨交易量和日均持倉量，您將獲得<b>{tickets} 張抽獎券</b>。",
  "earnLotteryTicketsInfoNew": "根據您報名參與抽獎後的 VIP 等級、現貨交易量和日均持倉量，您將獲得 {tickets} 張抽獎券。",
  "earnMaxVipLotteryTicketsInfo": "根據您報名參與抽獎後的 VIP 等級、現貨交易量和日均持倉量，您將獲得<b>{tickets} 張抽獎券</b><b1>（額外抽獎券數量上限）</b1>。",
  "eeaCustomerParticipationProhibited": "本活動不面向來自以下國家/地區的用戶開放：奧地利、比利時、保加利亞、克羅地亞、塞浦路斯、捷克共和國、丹麥、愛沙尼亞、芬蘭、法國、德國、希臘、匈牙利、愛爾蘭、意大利、拉脫維亞、立陶宛、盧森堡、馬耳他、荷蘭、波蘭、葡萄牙、羅馬尼亞、斯洛伐克、斯洛文尼亞、西班牙、瑞典、冰島、列支敦士登和挪威（「歐洲經濟區」）。所有歐洲經濟區的用戶均不符合參與資格。",
  "eligibilityLaunchpadEventNotice": "要參與 Launchpad 活動，請在您的 Bybit 賬戶中買入或儲值所需金額的 MNT 或 USDT，並在快照期結束前一直持有資產，然後在申購期質押 MNT 或 USDT 代幣。",
  "eligibleForLaunchpad": "<p>參與者必須完成 1 級個人身份認證或企業認證，方有資格參與 Launchpad 活動。請注意，來自服務受<a href=\"{link1}\" target=\"_blank\">限制國家/地區</a>的用戶無法參與 Launchpad 項目。<p>\n\n<p>身份認證必須在申購期開始前完成。請點擊<a href=\"{link2}\" target=\"_blank\">此處</a>完成認證。<p>",
  "end": "結束時間",
  "ended": "已結束",
  "ended1": "已結束",
  "eventParticipationEligibility": "很抱歉，您不能參與本次活動。更多相關信息，請參閱條款與條件。",
  "example": "示例",
  "exampleBak": "示例：",
  "fiat": "法幣",
  "filter": "篩選",
  "finalSnapshotCalculationNotification": "正在計算您的最終快照持倉量。您可於 {time} (UTC) 查看自己是否符合資格。",
  "finalSnapshotCalculationNotificationNew": "正在計算您的最終快照持倉量。請於 {time} (UTC) 投入資金完成申購。",
  "finalTokenAllocation": "<p>在申購期，您需要訪問 <a href=\"{link}\" target=\"_blank\">Bybit Launchpad</a> 並點擊「立即投入」，為新項目投入一定數量的 MNT。<p>\n\n<p>最終代幣分配數量 = (個人投入的 MNT 數量 / 所有參與者投入的 MNT 總量) * 分配到項目的新代幣總量<p>\n\n<p>我們來舉例說明：<p>\n\n<p>Bob 投入的 MNT 數量：1,000 MNT<p>\n<p>所有參與者投入的 MNT 總量：1,000,000 MNT<p>\n<p>項目分配的新代幣（假設為「β」）總量：3,000,000 β<p>\n\n<p>在這種情況下，Bob 的最終分配數量為 3,000 β，計算方式如下：<p>\n<p>(1,000 MNT / 1,000,000 MNT) * 3,000,000 β<p>",
  "finish": "確認",
  "from": "開始時間",
  "fundingAccount": "資金賬戶",
  "fundingAccountSnapshotInfo": "<p>- 您的 MNT 或 USDT 餘額，以及質押在 Launchpool 和活期儲蓄中的 MNT 或 USDT，將自動計入您資金賬戶的資產快照。質押在定期儲蓄、雙幣投資以及跟單交易 Pro 等其他產品中的資產不計算在內。</p>",
  "fundingAndDerivativesAc": "<p>資產快照期間，資金賬戶、現貨賬戶及合約賬戶（或統一交易賬戶和反向合約賬戶）中的 MNT 或 USDT 餘額將會計算在內。<p>\n\n<p>- 對於資金賬戶，在活期儲蓄和 Launchpool 中質押的 MNT 將自動計入資金賬戶的資產快照。質押在其他 Bybit 理財產品（如流動性挖礦）和結構化產品（如雙幣投資）中的 MNT 不計入快照。<p>\n\n<p>- 對於合約賬戶，錢包餘額將會計算在內。請注意，錢包餘額可能會受到已結盈虧的影響。<p>",
  "gainEarlyAccessToTokens": "率先獲得 Bybit 明星項目的代幣",
  "getLotteryTicketNotice": "投入 {minPledgeAmount} {currency} 參與抽獎，即可獲得 1 張抽獎券，點擊瞭解如何<a href=\"{url}\" target=\"_blank\">獲得更多抽獎券</a>。",
  "getMoreTickets": "獲得更多抽獎券",
  "getVerified": "去認證",
  "global_setting_quick_order_desc": "<p>1. 市價單（快捷下單）</p>\n<p>2. 請注意，填寫的購買數量可能與輸入的訂單數量略有不同。 </p>",
  "global_setting_quick_order_label": "快捷下單",
  "global_setting_title": "自定義設置（適用於現貨）",
  "gridDcaBot": "網格機器人、定投機器人",
  "hint": "提示",
  "holdAvgMinPledgeBetweenTimeUtc": "{time1} – {time2} (UTC) 期間，日均持倉量至少達到 {minPledgeAmount} {currency}",
  "holdingsCalculationForMntOrUsdt": "如何計算參與 MNT 申購或 USDT 抽獎的持倉量？",
  "initialTokenSale": "{token} 首次代幣發售",
  "innovateQuota": "可用額度",
  "inverseDerivativesAccount": "反向合約賬戶",
  "joinLaunchpadPurchaseLink": "與我一起參與 {token} Launchpad，玩轉發行價買幣！點擊此處：",
  "joinLaunchpadPurchaseTip": "與我一起參與 {token} Launchpad，玩轉發行價買幣！",
  "joinLotteryBeforeTimeUtc": "請在 {time} (UTC) 前參與抽獎。",
  "joinLotteryWinAllocation": "投入 {currency}，參與抽獎，即有機會獲得 {token} 分配",
  "joinLotteryWithAvgBalance": "日均持倉量至少達到 {minPledgeAmount} {currency}，即可參與抽獎，有機會獲得 {token} 分配。",
  "joinSubscriptionBeforeTimeUtc": "請在 {time} (UTC) 前參與申購。",
  "joinTokenSale": "加入 {token} Launchpad！",
  "kline": "K線",
  "l_version_tip": "目前版本不支援Launchpad活動，請更新至最新版！",
  "launchpad": "Launchpad",
  "launchPad": "Launchpad",
  "leverage": "槓桿倍數",
  "leverage_off_trade_tip": "請開啟槓桿，然後參與槓桿交易。",
  "leverageCloseErrInfo": "操作失敗！您需要還清全部欠款後，才能關閉槓桿交易。",
  "leverageCloseTips": "Failed to disable Margin Trading, as there are active Spot Margin orders in your account.",
  "leveragedTokens": "槓桿代幣",
  "leverageLoanTips": "操作失敗！您的統一保證金賬戶的 IM 或 MM 佔用率已超過預警值。",
  "leverageTryAgain": "系統異常，請您稍後重試！",
  "liquidationErrorInfo": "操作失敗！賬戶已觸發強制平倉。",
  "loading_text": "正在載入",
  "loan": "借款",
  "loan_spot_account": "現貨賬戶",
  "login": "登錄",
  "loginToCheck": "登錄查看",
  "lotteryDrawDefinition": "什麼是代幣分配抽獎？",
  "lotteryEligibilityCongrats": "恭喜！您符合抽獎參與資格。",
  "lotteryEligibilityReminder": "恭喜！您符合認購資格。繼續持有您的資產直到快照期結束，然後在認購期間內返回此頁面，以投入您的USDT代幣。",
  "lotteryJoinErrorTip": "抱歉！您的日均持倉量未達到參與抽獎的最低資格要求，因此您不能參與抽獎。下次 Launchpad 請確保 {currency} 儲值數額達到要求。",
  "lotteryTicketsAllocation": "<p>代幣分配抽獎是指透過隨機抽取中獎券來確定中獎者。透過抽獎，幸運參與者將贏得新代幣的分配權。<p>\n\n<p>在每次 Launchpad 活動中，參與者最多可獲得的抽獎券數量取決於在快照期間完成的任務數量。獲得的抽獎券越多，贏得代幣分配的幾率越大。<p>",
  "lp_active_active": "進行中",
  "lp_active_before": "註冊",
  "lp_active_end": "已結束",
  "lp_active_joined": "加入成功！",
  "lp_asset_statistics": "資產快照",
  "lp_asset_statistics_desc": "在 5 天週期內，您現貨帳戶和合約帳戶的錢包餘額（以美元計算）將通過每小時快照記錄。在此期間，錢包餘額越高，獲得的 {currency} 幣就越多！",
  "lp_balance": "錢包餘額",
  "lp_balance_explain": "在 5 天計算期內，您的平均每日錢包餘額（以美元計算）將通過每小時快照進行記錄並在 UTC 時間次日凌晨 3 點更新。<br>假設在 9 月 24 日，Bob 註冊了 Bybit，並在 UTC 時間晚上 9 點存入價值 100 美元的存款。他的錢包餘額每小時快照將在 UTC 時間晚上 9 點記錄為 100 美元，UTC 時間晚上 10 點記錄為 200 美元，UTC 時間晚上 11 點記錄為 300 美元。因此，他在 9 月 24 日的平均每日錢包餘額為 25 美元*。在 UTC 時間 9 月 25 日凌晨 3 點，Bob 將看到他在 9 月 24 日的平均每日錢包餘額更新為 25 美元。<br>*[($100 + $200 + $300)/24] = $25 <br>您在這 5 天計算期內的平均錢包總餘額越高，可獲得的 BIT 就越多！",
  "lp_balance_explain_close": "收起",
  "lp_balance_explain_open": "查看更多",
  "lp_btn_join": "立即加入",
  "lp_btn_kyc": "立即認證",
  "lp_issue_num": "分配總量",
  "lp_item_desc": "BIT 是 BitDAO 的原生代幣",
  "lp_join": "報名註冊階段",
  "lp_join_desc": "您必須在報名階段點擊報名以參加活動。報名成功後，您將自動獲得參與錦鯉抽獎和代幣發放的資格，最高可免費贏取 3,500 枚{currency}。請注意，在此期間之前，您無需進行任何註冊操作。您平均每日現貨帳戶和合約帳戶的錢包餘額快照將被自動記錄。請<a href=\"https://www.bybit.com/user/accounts/auth/personal\">點擊此處</a>立即完成 KYC L1 身份認證，以獲得參加活動的資格。",
  "lp_link_bps": "白皮書",
  "lp_link_rule": "活動規則",
  "lp_link_website": "官網",
  "lp_no_kyc": "Launchpad 要求完成 1 級 KYC。",
  "lp_project_community": "社媒平台",
  "lp_project_desc": "簡介",
  "lp_project_desc_content": "BitDAO 是全球最大的去中心化自治組織（DAO）之一，旨在打造開放式金融以及去中心化的代幣經濟。",
  "lp_project_highlight": "項目亮點",
  "lp_project_highlight_desc": "BitDAO 是全球最大的去中心化自治組織（DAO）之一，主要支持者包括 Peter Thiel、Founders Fund、Pantera、Dragonfly、Spartan、Bybit 等。\n\n<br>Bybit 已承諾向 BitDAO 金庫提供常規捐贈。按 2021 年費率計算，每年將超過 10 億美元。\n\n<br>BitDAO 寄希望於加密技術的成功，並將分配大量資源來支援其發展。\n\n<br>BitDAO 可通過代幣兌換和共同開發開展專案合作。主要支持形式有：研發支持、流動性引導以及資金支持。",
  "lp_project_title": "BitDAO — 幣力同心",
  "lp_table_label1": "發放總量",
  "lp_table_label2": "代幣發放",
  "lp_table_label3": "錦鯉抽獎",
  "lp_table_label4": "個人上限（代幣發放）",
  "lp_table_label5": "個人上限（錦鯉抽獎）",
  "lp_tdk_desc": "在 Bybit 平台探索最具前景的新興加密貨幣項目，兼顧適應性框架、合法性和擴展潛力。",
  "lp_tdk_title": "Bybit Launchpad | 探索新興項目",
  "lp_time": "時間",
  "lp_token_distribution": "代幣發放階段",
  "lp_token_distribution_desc": "首先，我們會根據錦鯉抽獎結果計算您贏得的 {currency} 數量。其次，根據您在 5 天內現貨帳戶和合約帳戶的日均錢包餘額，計算您賺取的{currency} 數量。請注意，我們將 {currency} 發放至您的現貨帳戶大約需要 30 分鐘。",
  "lp10_introduce": "TAP FANTASY（TAP）：「P2E」奧多姆大陸",
  "lp10_introduce_desc2": "「Tap Fantasy 為免費 MMORPG 區塊鏈遊戲，設定 200 多個角色配備不同 NFT 面板，以 P2E 模式執行。玩家可自由探索開放世界，建設自己的元宇宙！",
  "lp10_introduce_desc3": "<br>Tap Fantasy 最初以 TapTap Fantasy 在 Facebook Gaming 發佈，並迅速成為平台最受歡迎的角色扮演冒險類遊戲。遊戲在不到六個月的時間吸引超過 150 萬用戶，日均活躍使用者數量（DAU）接近 40 萬。2021 年 9 月底，TapTap Fantasy 全球使用者量已超過 2000 萬。\n\n<br> 第三方遊戲開發者可透過 Tap Fantasy 的無程式碼地圖編輯器建立和設計遊戲模組。玩家還可以上傳自己設計的 NFT 頭像、壁紙、外形、皮膚等內容。買到 NFT 面板後，玩家可以進入 VIP 打寶區獲得遊戲代幣和其他玩家設計的 NFT 皮膚。\n\n<br>TAP 代幣為 Tap Fantasy 的 DAO 治理代幣，具備常規 DAO 治理功能。 ",
  "lp10_project_desc": "「P2E」奧多姆大陸",
  "lp3_introduce": "Genopets — 您的 NFT 精神動物",
  "lp3_introduce_desc2": "Genopets 是一款建構於 Solana 的 NFT 遊戲，完美融合「免費遊戲」與「運動賺幣」的理念。在遊戲中探索 Genoverse 時，玩家可透過現實世界的運動賺取加密貨幣。",
  "lp3_introduce_desc3": "<br>Genopets 開創了一種全新遊戲類別，即「運動賺幣」。它融合了移動遊戲中的免費遊戲與區塊鏈生態系統中「邊玩邊賺」的精華。\n\n<br>Genopets 將玩家在現實世界中的身體運動與之在 Genoverse 中的發展與價值創造聯繫起來。\n \n<br>目前，Genopets 籌集到 830 萬美元的種子輪融資，由 Konvoy Ventures、Pantera Capital 以及加密貨幣、遊戲和健身領域的著名天使投資人領投。",
  "lp3_project_desc": "Genopets — 您的 NFT 精神動物",
  "lp4_introduce": "Pintu — 印度尼西亞加密貨幣交易所",
  "lp4_introduce_desc2": "Pintu 成立於 2020 年 4 月，是印度尼西亞商品期貨交易監管局（BAPPEBTI）監管的加密貨幣持牌經紀商。",
  "lp4_introduce_desc3": "<br>Pintu 關注初次投資加密貨幣的用戶，已經在 A1 輪融資中籌集了 3500 萬美元。\n \n<br>Pintu 得到了主流加密貨幣投資者的支持，包括 Pantera Capital、Coinbase Ventures、Intudo Ventures 等。\n \n<br>在成立一年半的時間內，Pintu 吸引了逾 100 萬活躍用戶。",
  "lp4_project_desc": "印度尼西亞加密貨幣交易所",
  "lp5_introduce": "Symbiosis Finance (SIS) - 多鏈流動性賦能者",
  "lp5_introduce_desc2": "Symbiosis Finance (SIS) 是一種去中心化多鏈流動性協議，允許使用者以低滑點在鏈間交換代幣，同時繼續成為資金的唯一所有者。",
  "lp5_introduce_desc3": "<br>Symbiosis Finance 為所有 Layer 2 解決方案和前景光明的 Layer 1 平臺（如 Solana、Algorand 和 Near ）聚合去中心化交易所的流動性。\n \n <br>Symbiosis Finance 提供無限的跨鏈流動性，它儘可能多地為所有鏈上的代幣對提供服務，同時也為任意代幣對之間的交換提供最優價格。\n \n <br>Symbiosis Relayers 網路是一種無許可性點對點中繼者網路，獨立於區塊鏈，內建加密貨幣經濟激勵機制。",
  "lp5_project_desc": "多鏈流動性賦能者",
  "lp6_daily_wallet_desc": "4 天資產快照期內，您資金賬戶、現貨賬戶及合約賬戶（或統一保證金賬戶/統一交易賬戶和反向合約賬戶）中的日均持倉量將透過每小時資產快照進行記錄。當天的日均持倉量將於次日 3:00 (UTC) 更新。\n\n舉例說明：假設 Bob 在 10 月 28 日註冊了 Bybit 賬戶，並從 21:00 (UTC) 開始每小時為資金賬戶儲值 100 MNT。Bob 的每小時餘額快照記錄如下：21:00 (UTC) 100 MNT，22:00 (UTC) 200 MNT，23:00 (UTC) 300 MNT。因此，10 月 28 日 Bob 資金賬戶中的 MNT 日均持倉量將達到 25 MNT。\n\n[(100 + 200 + 300) / 24] = 25 \n\n10 月 29 日 3:00 (UTC) 之後，Bob 會看到其 10 月 28 日的 MNT 日均持倉量（資金賬戶）更新為 25 MNT。",
  "lp6_daily_wallet_desc_v2": "在 {snapshot_days} 天快照期內，您資金賬戶、現貨賬戶及合約賬戶（或統一交易賬戶和反向合約賬戶）中的日均持倉量將透過每小時資產快照進行記錄。當天的日均持倉量將於次日 3:00 (UTC) 更新。\n\n假設 Bob 在 10 月 28 日註冊了 Bybit 賬戶，並從 21:00 (UTC) 開始每小時為現貨賬戶儲值 100 MNT。Bob 的每小時餘額快照記錄如下：21:00 (UTC) 100 MNT，22:00 (UTC) 200 MNT，23:00 (UTC) 300 MNT。因此，10 月 28 日 Bob 現貨賬戶中的 MNT 日均持倉量將為 25 MNT。\n\n[(100 + 200 + 300) / 24] = 25\n\n10 月 29 日 3:00 (UTC) 之後，Bob 會看到他 10 月 28 日的 MNT 日均持倉量（現貨賬戶）更新為 25 MNT。",
  "lp6_introduce": "REAL—3D虛擬世界",
  "lp6_introduce_desc2": "Realy Metaverse（REAL）是一種 3D 虛擬世界。用戶在其中可以互動、鑄造和交易各種基於 NFT 的音樂、遊戲、時尚產品和收藏品。",
  "lp6_introduce_desc3": "<br>Realy Metaverse 在以太坊網路中開發了 Bearache，即包含 1 萬隻獨特小熊的系列收藏品。Bearache 不僅是虛擬寵物，也是會員專屬俱樂部的入場券。\n \n <br>Realy Metaverse 打造的 NFT 擁有與之匹配的實體等價物。這些實體等價物植入了 NFC 晶片，可輕鬆驗證其真實性。\n \n <br>Realy Metaverse 是在 Solana 中構建的第一個大型街頭文化元宇宙，提出了「邊生活邊賺錢」的新理念。\n \n <br>Realy Metaverse 獲得了 Alameda Research、Multicoin、三箭資本（Three Arrows Capital）和District0x 等眾多機構的支援。",
  "lp6_join_step1_desc": "在<b>{date}</b>期間，您的現貨賬戶、理財 賬戶和合約賬戶中的 BIT 日均餘額必須達到或高於 {amount}，相關數值將向下取整。",
  "lp6_join_step2_desc": "您可以在現貨賬戶中為新項目提交一定數量的 BIT。為此，您必須在訂閱期內點選「立即認購」按鈕，且您提交的 BIT 數量將被鎖定，在最終分配 {currency} 前無法進行劃轉、提現或交易。請注意，如果您在 Launchpool 中質押了 BIT，請前往「訂單&交易」 - 「理財賬戶」 - 「Launchpool」，先取消質押您的 BIT，然後手動將其轉移到現貨賬戶。如果您在理財賬戶或合約賬戶下持有 BIT，請手動將其轉入您的現貨賬戶。",
  "lp6_project_desc": "3D虛擬世界",
  "lp7_introduce": "izumi Finance (IZI) —多鏈「流動性即服務」供應商",
  "lp7_introduce_desc2": "izumi Finance 是 UniswapV3 中的多鏈「流動性即服務」 (LaaS) 供應商，其代幣為 IZI。",
  "lp7_introduce_desc3": "<br>Izumi Finance 是Uniswap V3 中首個針對可程式化流動性挖礦的多鏈挖礦協議。\n<br>它亦擴增 Uniswap V3 AMM 橋接至其他 Layer 2 鏈的功能。\n<br>Izumi Finance 旨在降低跨鏈轉移代幣的時間與成本。\n 透過 Izumi 平台，不足 1 分鐘即可完成跨鏈轉移代幣，手續費不足 1 美元。\n<br>Izumi Finance 由 IOSG Ventures、Everest Ventures Group (EVG)、Cadenza Capital Management、\n Fenbushi Capital、GSR Ventures、CyberX、HashKey、Nansen 等眾多公司的投資。",
  "lp7_project_desc": "多鏈「流動性即服務」供應商",
  "lp8_introduce": "Kasta (KASTA) — 免費、高效的加密貨幣支付方式",
  "lp8_introduce_desc2": "Kasta 是一個進行即時且跨境的點對點加密貨幣交易的支付平台。此外，Kasta 不會針對以相同加密貨幣或兩個用戶之間進行的交易收取費用。",
  "lp8_introduce_desc3": "<br>Kasta 系統讓加密貨幣新手能輕鬆、自由並即時在最安全的環境下儲存、劃轉及接收加密貨幣。用戶只要新增朋友的電話號碼或電子郵件地址，或者掃描二維碼，便能在 Kasta 平台上交易加密貨幣。\n \n<br>Kasta 的換幣引擎讓用戶對想收到的加密貨幣或法定貨幣具有完整控制權，不受傳送人所使用的幣別所限制。Kasta 同時也在開發其他簡易好用的法定貨幣出入金服務，讓 Kasta 與銀行轉帳能互通，且能直接轉出貨幣給 Kasta 外的簽賬金融卡。\n\n<br>Kasta 亦在開發讓用戶可延後支付網路購物款項的獨特支付解決方案。用戶透過 Kasta 能選擇支付時間及支付的方式。\n \n<br>KASTA 是 Kasta 生態系的原生代幣，持有人可享有一系列好處，包括較低的轉移費用及回饋金。",
  "lp8_project_desc": "免費、高效的加密貨幣支付方式",
  "lp9_introduce": "MONSTER GALAXY P2E (GGM)：邊玩邊贏經典的 MONSTER GALAXY 系列",
  "lp9_introduce_desc2": "MONSTER GALAXY P2E 是經典手遊系列的區塊鏈遊戲版，玩家能以 NFT 形式擁有怪獸寵物，並贏取與交易遊戲代幣 GGM，藉此取得遊戲寶物。",
  "lp9_introduce_desc3": "<br>MONSTER GALAXY 自 2011 年首次發售以來，已吸引超過 2,500 萬名用戶，最新遊戲版本更加入 NFT 與邊玩邊贏的元素。\n \n<br>在 MONSTER GALAXY P2E 中，每隻由玩家在遊戲中訓練的怪獸 MOGA 皆代表獨一無二的 NFT，可於遊戲內建的虛擬商店或其他主要 NFT 市集進行交易。MOGA 的稀有等級可分為七 (7) 級。 \n \n<br>玩家亦可與怪獸和其他玩家對決，藉此贏取遊戲中使用的代幣 Galaxy Gems，簡稱為 GGM。GGM 可用來購買遊戲所需的能量與 MOGA 的額外籌碼。亦可用於取得特權和質押獎勵。GGM 和所有遊戲寶物皆可於任何支援的開放市場進行交易。\n \n<br>MONSTER GALAXY P2E 預期於 2022 年 2 月釋出測試版，並於 2022 年 3 月正式發售。",
  "lp9_project_desc": "邊玩邊贏經典的 MONSTER GALAXY 遊戲",
  "lpCalculatorNoticeContent1": "如果您已按計算器建議的數額提高儲值量且並未進行任何提幣，則無需再追加買入即可參與抽獎。您的最終錢包餘額將於 {time} 3:30 (UTC) 更新。",
  "lpCalculatorNoticeContent2": "您的每日錢包餘額根據每小時錢包餘額快照計算。最終錢包餘額為每日錢包餘額的平均值。",
  "lpCalculatorNoticeTitle": "溫馨提示",
  "lpCalculatorSubTitle2Ticket": "獲得 2 張抽獎券",
  "lpCalculatorSubTitle3Ticket": "獲得 3 張抽獎券",
  "lpCalculatorTicketOpt1": "方式 1：在 {time1} (UTC) 之前再完成 {tradingAmount} USDT 的現貨交易",
  "lpCalculatorTicketOpt2": "方式 2：在 {time2} (UTC) 之前再充入 {holdingsAmount} USDT 等值資產",
  "lpCantToSubscribeSameUser": "每位用戶只能使用一個已完成身份認證的賬戶參與當前的 Launchpad 活動。您已使用 UID {uid} 加入 Launchpad，因此無法再使用當前的 Bybit 賬戶參與當前的 Launchpad 活動。",
  "lpCantToSubscribeTrade": "您的賬戶餘額未達到最低要求。請在下次快照期間進行符合條件的儲值。",
  "lpCantToSubscribeUser": "You cannot join the event due to a restriction on your account. The event is not available for institutional users, users associated with institutional users, and managed users.",
  "lpGetTicketCongratulation": "恭喜您獲得代幣分配抽獎資格！抽獎將於 {time} (UTC) 開始。",
  "lpGetTicketTip": "根據您當前的 VIP 身份、現貨交易量和日均持倉量，您將在參與抽獎後獲得 {tickets} 張抽獎券。",
  "lpHold": "持倉",
  "lpMoreTicketsBtnUpgradeVip": "升級為 VIP",
  "lpMoreTicketsCountTip": "您的抽獎券/抽獎券數量上限",
  "lpMoreTicketsSubTitle": "您可以透過以下 3 種方式獲得抽獎券：成為 VIP、滿足現貨交易量要求或滿足日均持倉量要求。但是，您只能透過這 3 種方式之一獲得抽獎券，以所獲抽獎券數量最多者為準。",
  "lpMoreTicketsTipBottom": "抽獎券將在用戶投入代幣參與抽獎後發放。",
  "lpMoreTicketsTipCalculator": "使用<b>計算器</b>計算需要追加的金額。",
  "lpMoreTicketsTipCheck": "查看交易量和持倉量數據",
  "lpMoreTicketsTradeMaxContent": "在 {date1} 到 {date2} 期間，現貨交易量至少達到 {TradingReqMax} USDT，或持倉量至少達到 {HoldingReqMax} USDT。",
  "lpMoreTicketsTradeMaxTitle": "現貨交易量 ≥ {TradingReqMax} USDT 或持倉量 ≥ {HoldingReqMax} USDT",
  "lpMoreTicketsTradeMinContent": "在 {date1} 到 {date2} 期間，現貨交易量至少達到 {TradingReqMin} USDT，或持倉量至少達到 {HoldingReqMin} USDT。",
  "lpMoreTicketsTradeMinTitle": "現貨交易量 ≥ {TradingReqMin} USDT 或持倉量 ≥ {HoldingReqMin} USDT",
  "lpMoreTicketsVipContent": "要獲得 4 張抽獎券，用戶成為 VIP 的時間不能晚於 {date} (UTC)。",
  "lpMoreTicketsVipSuccessContent": "您已成為 Bybit VIP 用戶，成功解鎖 4 張抽獎券。",
  "lpMoreTicketsVipTitle": "VIP 用戶",
  "lpn_active_income": "您的活動收益",
  "lpn_active_rule": "規則條款",
  "lpn_active_status1": "即將到來",
  "lpn_active_status2": "快照期間",
  "lpn_active_status3": "快照結算",
  "lpn_active_status4": "認購期間",
  "lpn_active_status5": "分發期間",
  "lpn_active_status6": "已結束",
  "lpn_add_holdings": "達到 {currency} 持倉量要求方可參與抽獎。",
  "lpn_add_holdings_trading": "達到 {currency} 持倉量和現貨交易要求方可參與抽獎。",
  "lpn_add_ticket": "額外抽獎券",
  "lpn_add_ticket_tips": "額外抽獎券將在用戶確認參與抽獎后發放。",
  "lpn_allocation_announced_time": "分配結果將在 {time} (UTC) 公布。",
  "lpn_amount_need": "需要追加買入的金額",
  "lpn_asset_table_th1": "時間",
  "lpn_asset_tip": "由於資產計算量較大，您現貨賬戶、理財賬戶、資金賬戶及衍生品賬戶（或統一保證金賬戶和反向合約賬戶）中的日均餘額更新可能存在延遲。請注意，您儲值的金額不一定會立即顯示在餘額中。",
  "lpn_available_balance": "可用餘額（資金賬戶）：",
  "lpn_available_balance_tip": "可用餘額顯示的是您可以投入的 MNT 數額上限，或是您的資金賬戶當前的 MNT 餘額，以數值較小的為準。如果您可以投入的 MNT 上限為 30,000，而您當前的 MNT 餘額為 29,000，那麼您的可用餘額將會顯示 29,000 MNT。",
  "lpn_available_balance_tip_asset": "可用餘額显示的是您可以投入的 BIT 數額上限，或是您資金賬戶當前的 BIT 餘額，以數值較小的為準。如果您可以投入的 BIT 上限為 30,000，而您當前的 BIT 餘額為 29,000，那麼您的可用餘額將會显示 29,000 BIT。",
  "lpn_avg_growth": "平均漲幅",
  "lpn_banner_subtitle": "Bybit 明星項目的代幣",
  "lpn_banner_title": "率先獲得",
  "lpn_btn_experience": "立即加入",
  "lpn_btn_go_kyc": "立即認證",
  "lpn_btn_join_now": "立即投入",
  "lpn_btn_lottery": "立即投入",
  "lpn_btn_my_order": "我的認購記錄",
  "lpn_btn_recharge_now": "立即充值",
  "lpn_buy": "買入 {currency}",
  "lpn_buy_explain": "通過信用卡、銀行轉賬、現金餘額等買入",
  "lpn_buy_more": "追加買入 {currency}，獲得更高項目代幣分配額度。",
  "lpn_buy_now": "立即購買",
  "lpn_calculator": "計算器",
  "lpn_calculator_holdings_required": "最低日均持倉量",
  "lpn_calculator_notice": "說明",
  "lpn_calculator_time": "*請務必在 {time} (UTC) 之前完成買入",
  "lpn_calculator_tips1": "根據最新快照結果，您需要額外買入/儲值 <b>{holdingsAmount}</b> 並交易 <b>{tradingAmount}</b>，才有資格參與抽獎活動。",
  "lpn_calculator_tips2": "根據最新快照結果，您需要額外買入/儲值 <b>{holdingsAmount}</b>，才有資格參與抽獎活動。",
  "lpn_calculator_tips3": "根據最新快照結果，您需要額外交易<b>{tradingAmount}</b>，才有資格參與抽獎活動。",
  "lpn_calculator_tips4": "根據最新快照結果，您需要買入/儲值 <b>{holdingsAmount}</b>，才有資格參與抽獎認購。",
  "lpn_calculator_use": "使用計算器計算需要追加買入的金額。",
  "lpn_calculator_user_holdings": "當前日均持倉量",
  "lpn_calculator_user_trading": "您的日均交易量",
  "lpn_canlendar": "我的快照",
  "lpn_cap_lottery": "每張中籤抽獎券的代幣分配額度（抽籤）",
  "lpn_cap_subscribe": "個人認購上限（認購）",
  "lpn_capita_income": "人均收益",
  "lpn_card_notice1": "請先登入並完成身份認證。",
  "lpn_card_notice8": "快照期已結束。認購和抽獎即將開始。",
  "lpn_card_only_abailable_vip": "僅限 VIP",
  "lpn_card_purchase_limits": "購買限額",
  "lpn_card_vip_level_tip_supreme": "至尊 VIP",
  "lpn_card_vip_level_tip_title": "非 VIP 用戶不能參與本次代幣分配抽籤。",
  "lpn_card_vip_level_tip_user": "VIP 用戶",
  "lpn_choose_notice": "您可以用 BIT 申購，或用 USDT 參與抽獎！",
  "lpn_choose_notice_v2": "您可以使用 {currency} 申購，或使用 USDT 參與抽獎！",
  "lpn_commit_more": "立即追加",
  "lpn_community_link": "立即體驗",
  "lpn_community_tip": "iPhone 13 Pro 和 $ 20,000 獎金池",
  "lpn_community_title": "在 Telegram 上加入 Bybit 的現貨社群，贏得 iPhone 13 Pro 並瓜分 20,000 美元的獎金池！",
  "lpn_cover_enough_upgrade_vip": "要參與代幣分配抽籤，您必須在 {time} (UTC) 前升級為 VIP 用戶。",
  "lpn_currency": "已投入代幣",
  "lpn_deposit": "儲值 {currency}",
  "lpn_deposit_explain": "通過錢包或第三方交易平台儲值",
  "lpn_deposit_trade": "儲值/交易",
  "lpn_deposit_trade_title": "儲值並交易，即有機會獲得抽獎券",
  "lpn_desc": "參與Bybit Launch系列活動，獲得首發新代幣",
  "lpn_distribution": "分配",
  "lpn_distribution_time": "分配期",
  "lpn_enable_lottery": "恭喜，您已達到參加抽獎要求。",
  "lpn_enable_subscribe": "恭喜，您已達到認購要求。",
  "lpn_exchange_rate_tip": "${number} （ {currency0} 與 {currency} 的匯率將在申購期開始時確定）",
  "lpn_expand_more": "查看更多",
  "lpn_faq": "常見問題",
  "lpn_get_more_ticket": "獲得更多抽獎券",
  "lpn_get_ticket": "根據您的註冊時間和參與抽獎活動后的日均交易量，您將額外獲得 {tickets} 張抽獎券。",
  "lpn_go_trade": "立即交易",
  "lpn_higher_commit": "認購金額越高，可獲分配的 {token} 越多，個人上限為 {limitAmount} {token}。",
  "lpn_history": "歷史上回報最高的 Launchpad 項目",
  "lpn_holdings": "{currency} 持倉量",
  "lpn_holdings_calculated": "正在計算您的最終快照持倉量。您可在 {time} (UTC) 查看結果。",
  "lpn_holdings_calculator_title": "{currency} 快照持倉量計算器",
  "lpn_holdings_fail": "您資產快照期間的當前持倉量未能達到要求。",
  "lpn_holdings_trading_calculated": "正在計算您的最終快照持倉量和日均交易量。您可在 {time} (UTC) 查看結果。",
  "lpn_holdings_trading_fail": "您資產快照期間的當前持倉量和日均交易量未能達到要求。",
  "lpn_holdings_trading_update": "您的日均持倉量和交易量將於 {date}3:00 (UTC) 更新。",
  "lpn_holdings_update": "您的日均持倉量將於 {date}3:00 (UTC) 更新。",
  "lpn_how_join": "參與方式",
  "lpn_index": "首頁",
  "lpn_index_avg_tips": "所有 Launchpad 項目上線後第一周的平均回報率。",
  "lpn_input_quantity": "總投入金額",
  "lpn_introduce": "CropBytes — 虛擬經濟遊戲",
  "lpn_introduce_desc2": "CropBytes 是模擬現實世界農業經濟的加密貨幣遊戲，可供用戶利用加密貨幣在虛擬世界中遊玩以及賺取收益。CBX 代幣是 CropBytes 元界不可或缺的一部分，並與所有遊戲內活動相關聯。",
  "lpn_introduce_desc3": "<br>CropBytes 元界中的價格走勢完全依供需關係，因此玩家可以完全控制經濟形態。 \n \n <br>CropBytes 擁有自己的市場和專門的內建交易所，可供玩家順利交易資產。\n \n <br>CropBytes 為玩家提供同質化代幣和非同質化代幣 (NFT)，藉以解決低流動性以及允許高頻率交易等問題。",
  "lpn_introduce_t1": "社媒平台",
  "lpn_introduce_t2": "項目簡介",
  "lpn_introduce_t3": "項目亮點",
  "lpn_introduce_td3": "{scale} 發行總量",
  "lpn_introduce_td4": "{number} 美元（BIT 和 {currency} 的兌換價格將於認購期前確認）",
  "lpn_introduce_td7": "無鎖倉",
  "lpn_introduce_td9": "分配期間",
  "lpn_introduce_th2": "分配總量",
  "lpn_introduce_th3": "初始流通量",
  "lpn_introduce_th4": "價格",
  "lpn_introduce_th5": "對於 Launchpad 分配的總數",
  "lpn_introduce_th6": "個人分配上限",
  "lpn_introduce_th7": "代幣鎖倉期",
  "lpn_introduce_th8": "代幣類型",
  "lpn_introduce_th9": "代幣分配",
  "lpn_investment": "您的投資",
  "lpn_invite": "邀請好友",
  "lpn_invite_ad": "邀請好友，賺取<b>最高 120 MNT</b>！",
  "lpn_invite_ad2": "邀請好友交易現貨，賺取高達 30% 傭金！",
  "lpn_invite_go": "立即邀請",
  "lpn_invite_now": "邀請好友",
  "lpn_invite_rule": "規則說明",
  "lpn_invite_rule1": "1. 如何參與 Launchpad 推薦計劃？\n- 將邀請鏈接分享給好友，邀請他們註冊 Bybit 賬戶並報名參加即將開始的 Lauchpad 活動。每成功邀請一位好友，即可獲得一定數量的 MNT 獎勵。\n- 受邀好友應註冊 Bybit 賬戶，並參加本次 Launchpad 的代幣分配申購或錦鯉抽獎活動。\n- Lauchpad 活動的有效期為官方宣布開始至申購期結束。請在社交媒體關注 Bybit 或訪問 Launchpad 主頁，查看活動時間。\n- 每場 Lauchpad 活動可邀請 10 位好友，您最高可獲得 120 MNT。\n- 如果受邀好友成為 Bybit 代理，則您不能獲得獎勵。",
  "lpn_invite_rule2": "2. 獎勵如何分發？\n- 如果您已成功邀請任何符合條件的新用戶參加活動，則獎勵的 MNT 總額將在 Launchpad 活動結束 1 個月後計入您的資金賬戶。",
  "lpn_invite_rule2_asset": "<b>2. 獎勵的具體發放方式如何？</b>\n- 如果您已成功邀請任何符合條件的新用戶參加活動，則獎勵的 BIT 總額將在 Launchpad 活動結束后 1 個月計入您的資金賬戶。",
  "lpn_invite_tab1": "分享連結",
  "lpn_invite_th1": "累計推薦好友人數",
  "lpn_invite_th2": "單個成功推薦獎勵",
  "lpn_invite_title": "推薦好友同賺 BIT",
  "lpn_invite_title_mnt": "邀請好友，贏取 MNT",
  "lpn_is_high_vip_tip_text": "您已達到本次代幣分配抽獎的最高購買限額。您的購買限額為 {amount} {currency}。",
  "lpn_issue_items_total": "項目",
  "lpn_join": "立即加入",
  "lpn_join_ad": "參與 Bybit Launchpad 活動，率先獲得高潛力項目代幣！",
  "lpn_join_go": "立即參與",
  "lpn_join_step": "活動時間",
  "lpn_join_step1_desc": "在<b>{date}</b>期間，您的現貨賬戶和理財賬戶中的 BIT 日均餘額必須達到或高於 {amount}，相關數值將向下取整。",
  "lpn_join_step1_desc_v2": "1. The daily average holdings of the committed token (MNT or USDT) and trading volume during the snapshot period must be equal to or greater than the minimum threshold amount. ",
  "lpn_join_step1_title": "資產快照期",
  "lpn_join_step2_desc": "若要向新項目投入 BIT，您必須在認購期內點選「立即認購」。您可以投入的 BIT 數量上限取決於現貨賬戶和理財賬戶於 5 天持倉快照期的 BIT 日均持倉量。請注意，參與認購後，平台將暫時鎖定您投入的 BIT 數額，在最終發放 {currency} 前無法劃轉、提幣或交易。",
  "lpn_join_step2_title": "訂閱期間",
  "lpn_join_step3_desc": "{currency} 最終分配數量 =（您投入的 BIT 數量 / 所有參與者投入的 BIT 數量）* 為項目分配的 {currency} 總量。請注意，您可以領取的 {currency} 上限為 {limit}，超出限額的部分將分配給尚未達到上限的參與者。根據最終的 {currency} 分配結果，系統將從投入的金額中扣除相應的 BIT 等值金額，而分配到的 {currency} 和剩餘的 BIT 將返還至您的現貨賬戶。",
  "lpn_join_step3_title": "分配期",
  "lpn_join_step4_date": "如果達到流動性條件，新代幣預計將於 {date} （UTC）上線 Bybit 現貨交易平台。",
  "lpn_join_step4_title": "發佈期間",
  "lpn_kyc_lottery": "請完成 1 級 KYC，才能參與抽獎。",
  "lpn_kyc_subscribe": "請完成 1 級 KYC，才能參與認購。",
  "lpn_launchpad": "Launchpad",
  "lpn_launchpool": "FreshCut Diamond (FCD)",
  "lpn_launchpool_desc": "FCD 是 FreshCut 遊戲內容平台的社區代幣，用戶可在社區中創作賺幣或參與賺幣，平台還會用代幣來獎勵創作者。",
  "lpn_launchpool_title": "質押賺取免費代幣",
  "lpn_learn_join": "立即開始",
  "lpn_link_bps": "白皮書",
  "lpn_link_research": "研究報告",
  "lpn_link_rule": "活動規則",
  "lpn_link_website": "官網",
  "lpn_list": "列表頁",
  "lpn_log_snapshot": "登錄即可查看您的最新快照結果。",
  "lpn_login": "登錄",
  "lpn_lottery": "錦鯉抽獎",
  "lpn_lottery_announced_time": "抽獎結果將在 {time} (UTC) 公布。",
  "lpn_lottery_calculator_notice1": "日均持倉量將根據您的錢包餘額每小時快照計算得出。最終賬戶持倉量為您每日錢包餘額的平均值。",
  "lpn_lottery_calculator_notice2": "正在計算您的最終賬戶持倉量。您可在 {time} (UTC) 查看結果。",
  "lpn_lottery_calculator_notice3": "日均交易量將根據資產快照期間您現貨交易量的每小時快照計算得出。",
  "lpn_lottery_card_desc": "日均持倉量和交易量達到最低要求後，投入 {minPledgeAmount} {currency} 即可獲得一張抽獎券，更有機會贏取 {token}！每張抽獎券抽中後可贏取 {limitAmount} {token}！",
  "lpn_lottery_card_desc_v2": "日均持倉量達到要求後，投入 {minPledgeAmount} {currency} 即可獲得一張抽獎券，有機會贏取 {token}！每張抽獎券中獎後均可獲得 {limitAmount} {token}！",
  "lpn_lottery_chosen": "兩項活動二選一。您選擇投入 {currency} 以獲得抽獎券。",
  "lpn_lottery_confirm_tips": "投入 {amount1}{currency} 獲取抽獎券，中獎後可贏取 {amount2} 新代幣！",
  "lpn_lottery_currency": "使用 {currency} 進行抽獎",
  "lpn_lottery_desc": "投入 {currency} 以贏取項目代幣分配權。",
  "lpn_lottery_enbale": "恭喜，您已滿足抽獎要求。抽獎將於 {time} (UTC) 開始。",
  "lpn_lottery_error_tips": "選擇用{currency1} 購買抽獎券後，您不能使用 {currency2} 認購項目代幣分配。",
  "lpn_lottery_no": "您的抽獎號碼",
  "lpn_lottery_not_cover_min_valom": "抱歉，您未能達到本次 Launchpad 的最低要求。請在下次 Launchpad 快照期結束前達到現貨交易量要求，或升級為 VIP 用戶。",
  "lpn_lottery_rate": "中獎概率",
  "lpn_lottery_start_time_tip": "抽籤將於 {time1} (UTC) 開始。",
  "lpn_lottery_total": "分配總量（抽獎）",
  "lpn_lottery_trading_tips": "由於資產計算量較大，您的日均交易量更新可能會存在延遲，交易訂單不一定會立即显示在日均交易量中。",
  "lpn_lucky_limit": "個人上限（幸運抽獎）",
  "lpn_min_holdings": "最低日均持倉量",
  "lpn_min_holdings_tips": "日均持倉量將根據資產快照期間賬戶餘額的每小時快照計算得出。",
  "lpn_min_input": "低於最小投入數量 {quantity}{coin}",
  "lpn_more_ticket_title": "如何獲取更多抽獎券",
  "lpn_more_trade": "交易量越大，獲得的抽獎券就越多。",
  "lpn_more_trade_content": "快照期間（{date1} ~ {date2}），達到日均現貨交易量要求的用戶將獲得額外抽獎券。",
  "lpn_new_rule1": "1.所有參與用戶需遵守 Bybit 條款與條件。",
  "lpn_new_rule2": "2.Bybit 有權取消利用惡意行為獲取盈利的用戶的參與資格，包括開設多賬戶以牟取追加贈金以及其他涉及非法、欺詐或造成有害影響的行為。",
  "lpn_new_rule3": "3.Bybit 保留對本次活動的最終解釋權。如果您有任何疑問，請聯絡我們的客服團隊。",
  "lpn_new_rule4": "4.Bybit 有權修改本次活動的條款。若有更改，恕不另行通知。",
  "lpn_new_rule5": "5.本網站所載內容不構成您在美國或進入美國（或其他從事此類活動非法的司法權區）境內向任何美國人或為其賬戶出售證券的邀約。\nBIT 代幣轉讓受適用法律的相關規定規限。在任何情況下，除非適用《1933 年美國證券法》（修訂版）的豁免規定，或屬於不受登記規定約束的交易，您不會在美國境內，或向任何美國人或為其賬戶或利益，重新發售、轉售或轉讓任何 BIT 代幣。任何於美國境內進行的任何 BIT 代幣公開發售將以招股章程的方式進行，您可向發行方或代幣銷售持有者索取，其中載有本公司及管理層詳細資料以及財務報表。",
  "lpn_new_rule5_v2": "本網站中包含的內容不構成在美國或相關行為屬於非法範疇的任何其他司法轄區內發售或銷售證券，亦不代表美國或此類司法轄區居民發售或銷售證券或是使其受益。\n\n根據適用法律規定，{currency0} 代幣划轉可能需要遵循法律限制。在任何情況下，{currency0} 代幣均不會在美國境內再次發售、轉售或划轉，亦不代表美國居民再次發售、轉售或划轉或是使其受益，美國《1933 年證券法》註冊登記要求豁免的情況/交易無需遵循相關要求的情況除外。{currency0} 代幣在美國境內的任何公開發售都將透過公開發行的方式完成，用戶可透過發行方或所售代幣持有者獲取代幣，並將包含關於公司和管理層的詳細信息，此外還會提供財務報表。",
  "lpn_new_user": "新用戶將額外獲得 1 張抽獎券。",
  "lpn_new_user_content": "活動期間（{date1} - {date2}）註冊的新用戶將額外獲得 1 張抽獎券。",
  "lpn_not_high_vip_tip_text": "要將您的購買限額提升至 {amount} {currency}，請在 {time} UTC 之前完成 VIP 升級。",
  "lpn_not_vip_tip_text": "要參與代幣分配抽籤，您必須在 {time} (UTC) 前升級為 VIP 用戶。",
  "lpn_notice_13": "快照期已結束。認購即將開啟。",
  "lpn_notice10": "本期活動已結束。",
  "lpn_notice11": "您現在可檢視所獲分配額度！新代幣即將上線 Bybit 現貨交易平台。",
  "lpn_notice12": "資產統計中。追加充值 {currency} 以獲得 {currency} 分配資格。您當天的賬戶餘額快照將於次日更新。",
  "lpn_notice14": "可購買抽獎券。投入 {currency} 以獲得抽獎券。",
  "lpn_notice15": "兩項活動二選一。",
  "lpn_notice16": "您的抽獎號為 {number}。",
  "lpn_notice17": "選擇交易對，開始交易！",
  "lpn_notice2": "只差一步即可參加活動。",
  "lpn_notice3": "資產快照期即將開始，請確保賬戶餘額充足。",
  "lpn_notice6": "資產統計中。追加充值 {currency} 以獲得更多項目代幣分配額度。您當天的賬戶餘額快照將於次日更新。",
  "lpn_notice7": "很遺憾，您的日均賬戶餘額不滿足活動要求，請關注我們的下期活動",
  "lpn_notice8": "認購進行中。投入 {currency} 以認購。",
  "lpn_notice9": "追加 {currency} 以獲得更大項目代幣分配額度。",
  "lpn_obtain_lottery_qualification": "恭喜！您符合投入 {amount} {currency} 參與代幣分配抽籤的條件。",
  "lpn_ok": "確定",
  "lpn_one_progress_info": "結果預期公佈於",
  "lpn_one_progress_title": "代幣分派中……",
  "lpn_only_vip_can_join": "僅 VIP 用戶可參與本次抽籤。",
  "lpn_order_amount": "投資",
  "lpn_order_btn": "我的認購",
  "lpn_order_btn_all": "全部",
  "lpn_order_btn_cancel": "取消",
  "lpn_order_btn_confirm": "確認",
  "lpn_order_dialog_abailable_balance": "可用餘額（資金賬戶）",
  "lpn_order_dialog_commit_amount": "投入數額",
  "lpn_order_dialog_title": "詳情",
  "lpn_order_max": "可投資的最大金額",
  "lpn_order_max_tip": "您可以投入的 BIT 數額上限取決於您在 5 天快照期內記錄的日均 BIT 餘額。",
  "lpn_order_max_tip_v2": "您可以投入的 MNT 數額上限取決於您在 5 天快照期內記錄的日均 MNT 餘額。",
  "lpn_order_submit_success": "成功！",
  "lpn_order_submit_success_desc": "您已向選取的項目投入 {num} {currency}。",
  "lpn_order_submit_success_desc1": "您已成功參與抽獎。",
  "lpn_order_tips": "登入後方可檢視訂單歷史。",
  "lpn_participant": "參加人數",
  "lpn_participants": "參與者",
  "lpn_paymeet_failed_dialog_buy_btn": "買入 {currency}",
  "lpn_paymeet_failed_dialog_content": "您的資金賬戶餘額不足。要繼續認購，您需要額外買入或儲值 {amount} {currency}。",
  "lpn_paymeet_failed_dialog_deposit_btn": "儲值 {currency}",
  "lpn_paymeet_failed_dialog_title": "付款失敗",
  "lpn_price": "價格",
  "lpn_product_life": "活動時間",
  "lpn_profit": "第一週平均收益",
  "lpn_profit_tips": "第一週平均收益 = 上線後第一週的平均價格/發行價 *100%",
  "lpn_project_desc": "在元界中建立您的加密小王國",
  "lpn_project_info": "項目介紹",
  "lpn_project_status0": "資產快照期將開始於",
  "lpn_project_status1": "距離認購開始",
  "lpn_project_status2": "距離認購截止",
  "lpn_project_status3": "距離分配結束",
  "lpn_project_status4": "已結束",
  "lpn_record_endtime": "結束日期",
  "lpn_record_name": "項目",
  "lpn_record_name_tip": "輸入項目名稱",
  "lpn_record_starttime": "開始日期",
  "lpn_record_state0": "待辦",
  "lpn_record_state1": "分配中",
  "lpn_record_state2": "完成",
  "lpn_record_th1": "時間",
  "lpn_record_th3": "已投代幣金額",
  "lpn_record_th3_m": "投入 {currency}",
  "lpn_record_th4": "價格",
  "lpn_record_th5": "抵扣代幣金額",
  "lpn_record_th6": "代幣分配數量",
  "lpn_record_th7": "狀態",
  "lpn_records": "記錄",
  "lpn_register": "註冊",
  "lpn_register_ticket": "成功註冊。您已獲得 1 張抽獎券。",
  "lpn_required_holdings": "日均持倉量要求",
  "lpn_required_trading": "日均交易量要求",
  "lpn_required_trading_tips": "日均交易量將根據資產快照期間您現貨交易量的每小時快照計算得出。",
  "lpn_required_tradings": "現貨交易量要求",
  "lpn_reset": "重置",
  "lpn_restricted_country": "受限制國家/地區",
  "lpn_restricted_country_tip": "Bybit 不向美國、中國大陸、新加坡、魁北克（加拿大）、朝鮮、古巴、伊朗、克里米亞、塞瓦斯托爾及蘇丹的居民或公民提供服務或產品。",
  "lpn_result_time": "分配結果",
  "lpn_result_title": "您的投資結果",
  "lpn_rewards_check_reason": "失敗原因",
  "lpn_rewards_default_name": "過往 Launchpad 活動",
  "lpn_rewards_faile_reason": "您目前不符合領取空投獎勵的條件。請向 Bybit 提交申訴，並在「案例類型」下選擇「活動」、「獎勵」和「Launchpad」。",
  "lpn_rewards_orders": "我的推薦獎勵",
  "lpn_rewards_request": "提交申訴請求",
  "lpn_rewards_source1": "{uid} 參與了活動",
  "lpn_rewards_source2": "過往用戶活動",
  "lpn_rewards_status_faile": "失敗",
  "lpn_rewards_status_pending": "處理中",
  "lpn_rewards_status_success": "已發放",
  "lpn_rewards_status_tips": "獎勵將在 Launchpad 活動結束後的 7 個工作日內發放至現貨賬戶。如未收到獎勵，請點擊「失敗原因」了解詳情。",
  "lpn_rewards_status_tips_asset": "獎勵將在 Launchpad 活動結束后 7 個工作日內發放至您的資金賬戶。如未收到獎勵，請點擊「失敗原因」了解詳情。",
  "lpn_rewards_th_event": "Launchpad 活動",
  "lpn_rewards_th_rewards": "獎勵",
  "lpn_rewards_th_source": "用戶活動",
  "lpn_rules": "活動規則",
  "lpn_scroll_load": "向下滾動查看更多",
  "lpn_select_deposit": "選擇儲值方式",
  "lpn_share_earn": "邀好友，賺獎勵",
  "lpn_share_img_content": "邀請好友，最高可獲 120 MNT！",
  "lpn_share_text": "參與 Bybit Launchpad 活動，率先獲得高潛力項目代幣！點擊此處：{link}",
  "lpn_share_text_label": "設置個性化邀請信息",
  "lpn_snapshot_buy_currency": "立即買入或儲值 {currency} ，即可認購更多代幣。",
  "lpn_snapshot_desc_content1": "5 天資產快照期間，您現貨賬戶、理財賬戶、資金賬戶及合約賬戶（或統一保證賬戶）中的日均持倉量將通過每小時資產快照進行記錄。當天的日均持倉量將於次日 3:00 (UTC) 更新。\n\n舉例說明：假設 Bob 在 10 月 28 日註冊了 Bybit 賬戶，並從 21:00 (UTC) 開始每小時為現貨賬戶儲值 100 BIT。Bob 的每小時餘額快照記錄如下：21:00 (UTC) 100 BIT，22:00 (UTC) 200 BIT，23:00 (UTC) 300 BIT。因此，10 月 28 日 Bob 現貨賬戶中的 BIT 日均持倉量將達到 25 BIT*。\n\n*[(100 + 200 + 300)/24] = 25 \n\n10 月 29 日 3:00 (UTC) 之後，Bob 會看到他 10 月 28 日的 BIT 持倉量（現貨賬戶）更新為 25 BIT。",
  "lpn_snapshot_desc_content1_asset": "5 天資產快照期間，您的資金賬戶、現貨賬戶及合約賬戶（或統一保證金賬戶、統一交易賬戶和反向合約賬戶）中的日均持倉量將透過每小時資產快照進行記錄。當天的日均持倉量將於次日 3:00 (UTC) 更新。\n\n舉例說明：\n假設 Bob 在 10 月 28 日註冊了 Bybit 賬戶，並從 21:00 (UTC) 開始每小時為資金賬戶儲值 100 BIT。Bob 的每小時餘額快照記錄如下：21:00 (UTC) 100 BIT，22:00 (UTC) 200 BIT，23:00 (UTC) 300 BIT。因此，10 月 28 日 Bob 資金賬戶中的 BIT 日均持倉量將達到 25 BIT。\n\n*[(100 + 200 + 300)/24] = 25\n\n10 月 29 日 3:00 (UTC) 之後，Bob 會看到其 10 月 28 日的 BIT 日均持倉量（資金賬戶）更新為 25 BIT。",
  "lpn_snapshot_desc_content2": "4 天快照期內，您現貨交易、現貨跟單交易、網格機器人、定投機器人、現貨槓桿交易和槓桿代幣的綜合日均交易量將透過每日快照進行記錄。其中包括您所有的買入和賣出交易。請注意，衍生品交易的交易量不計入其中。您當天的綜合日均交易量將於次日 3:00 (UTC) 更新。\n\n對於以 USDT 計價的交易對，交易量按所有已執行 USDT 訂單的價值總和計算；對於以非 UDST 計價的交易對，交易量將按當日收盤價換算為 USDT。\n\n假設 Bob 在 10 月 28 日註冊了 Bybit 賬戶，然後在 21:00 (UTC) 進行了 100 USDT 的現貨交易，又在 22:00 (UTC) 進行了 200 USDT 的現貨交易。他的日均交易量快照將記錄為 300 USDT。在本例中，他在快照期間的最終日均交易量為 60 USDT*\n\n*(100 + 200) / 5 = 60\n\n10 月 29 日 3:00 (UTC) 後，Bob 將看到他 10 月 28 日的日均交易量更新為 60 USDT。",
  "lpn_snapshot_desc_content2_v2": "在 {snapshot_days} 天快照期內，您現貨交易、現貨跟單交易、網格機器人、定投機器人、現貨槓桿交易和槓桿代幣的綜合累計交易量將透過每日快照進行記錄，其中包括您所有的買入和賣出交易。請注意，衍生品交易量不計入其中。您當天的綜合日均交易量將於次日 3:00 (UTC) 更新。\n\n對於以 USDT 計價的交易對，交易量為所有已成交 USDT 訂單的訂單價值之和。對於非 USDT 計價的交易對，交易量將根據當天收盤價折算為 USDT。\n\n假設 Bob 在 10 月 28 日註冊了 Bybit 賬戶，然後在 21:00 (UTC) 進行了 100 USDT 的現貨交易，又在 22:00 (UTC) 進行了 200 USDT 的現貨交易。在這種情況下，他在快照期間的累計總交易量將為 300 USDT。\n\n100 + 200 = 300\n\n10 月 29 日 3:00 (UTC) 之後，Bob 會看到他 10 月 28 日的累計交易量更新為 300 USDT。",
  "lpn_snapshot_desc_content3": "資產快照期間，您現貨賬戶、理財賬戶、資金賬戶及合約賬戶（或統一保證賬戶）的日均持倉量必須達到或超過最低閾值金額，並向下取整。\n\n您現貨賬戶、理財賬戶、資金賬戶及合約賬戶（或統一保證金賬戶）中的日均持倉量將於每天 3:00 (UTC) 更新。但是，由於計算量較大，您的日均持倉量更新可能會存在延遲。",
  "lpn_snapshot_desc_content3_asset": "資產快照期間，您的資金賬戶、現貨賬戶及合約賬戶（或統一保證金賬戶、統一交易賬戶和反向合約賬戶）中的日均持倉量必須達到或超過最低閾值金額，並向下取整。\n\n您的資金賬戶、現貨賬戶及合約賬戶（或統一保證金賬戶、統一交易賬戶和反向合約賬戶）中的日均持倉量將於每天 3:00 (UTC) 更新。但是，由於計算量較大，您的日均持倉量更新可能會存在延遲。",
  "lpn_snapshot_desc_title1": "持倉量是如何計算的？",
  "lpn_snapshot_desc_title1_v2": "如何計算參與 MNT 申購或 USDT 抽獎的持倉量？",
  "lpn_snapshot_desc_title2": "日均交易量是如何計算的？",
  "lpn_snapshot_desc_title2_v2": "如何計算現貨交易量，以確定我是否有資格獲得 2 張或 3 張抽獎券？",
  "lpn_snapshot_desc_title3": "快照規則",
  "lpn_snapshot_holding": "持倉訊息",
  "lpn_snapshot_holdings_title": "{currency} 持倉量快照",
  "lpn_snapshot_th_trading": "交易量",
  "lpn_snapshot_trading": "交易量詳情",
  "lpn_snapshot_trading_title": "交易量快照",
  "lpn_snapshot_update_time": "將於{date} 3:00 (UTC) 更新",
  "lpn_snapshots": "資產快照",
  "lpn_snapshots_time": "資產快照期",
  "lpn_spot_trading": "現貨交易量",
  "lpn_step_tips1": "<b>滿足條件：</b>在快照期結束前储值 BIT 或 USDT，確保錢包餘額達到認購或抽獎要求！",
  "lpn_step_tips1_v2": "<b>滿足條件：</b>在快照期結束前儲值 MNT 或 USDT，確保錢包餘額達到申購或抽獎要求！",
  "lpn_step_tips2": "<b>投入代幣：</b>投入 BIT 即可直接認購代幣分配，投入 USDT 即有機會贏取項目代幣分配額度。",
  "lpn_step_tips2_v2": "<b>投入代幣：</b>投入 MNT 即可直接申購代幣分配，投入 USDT 即有機會贏取項目代幣分配額度。",
  "lpn_step_tips3": "<b>分配期：</b>系統將在分配期為認購用戶分配代幣，並為參與抽獎的用戶抽取分配額度。",
  "lpn_step_tips4": "<b>查看結果：</b>在結果公佈後查看您的代幣認購分配或中獎所獲分配額度。現在就可以使用您獲得的新代幣進行交易了！",
  "lpn_sub_tip_text": "立即訂閱，隨時獲悉 Launchpad 活動更新！",
  "lpn_subscribe": "認購",
  "lpn_subscribe_chosen": "兩項活動二選一。您選擇投入 {currency} 以認購。",
  "lpn_subscribe_currency": "使用 {currency} 申購",
  "lpn_subscribe_desc": "投入 {currency} 進行申購，獲得代幣分配權。",
  "lpn_subscribe_error_tips": "選擇用 {currency1} 認購項目代幣分配後，則無法使用 {currency2} 購買抽獎券。",
  "lpn_subscribe_total": "分配總量（認購）",
  "lpn_subscription": "認購",
  "lpn_subscription_holding_tips": "由於資產計算量較大，您現貨賬戶、理財賬戶、資金賬戶及合約賬戶（或統一保證金賬戶）的日均持倉量更新可能會存在延遲，儲值金額不一定會立即显示在餘額中。",
  "lpn_subscription_holding_tips_asset": "由於資產計算量較大，您的資金賬戶、現貨賬戶及合約賬戶（或統一保證金賬戶、統一交易賬戶和反向合約賬戶）的日均持倉量更新可能會存在延遲，儲值金額不一定會立即顯示在餘額中。",
  "lpn_subscription_time": "認購期",
  "lpn_subscription_time2": "認購或抽獎",
  "lpn_subscriptions_orders": "我的認購",
  "lpn_subscrption_card_desc": "日均持倉量達到最低要求后，至少投入 {minPledgeAmount} {currency} 即可認購 {token}（每人認購上限為 {limitAmount} {token}）。",
  "lpn_tail_digit": "{num} Tail Digit",
  "lpn_tail_digit_num": "後{number} 位尾數",
  "lpn_tail_digit_num1": "最後一位數字",
  "lpn_tail_digits": "中獎號碼",
  "lpn_tail_digits_th1": "匹配",
  "lpn_tail_digits_th2": "中獎號碼",
  "lpn_time_label": "日期",
  "lpn_token_calculation": "代幣分配中……",
  "lpn_total_amount": "總投資",
  "lpn_total_funds_raised": "總投入金額（美元）",
  "lpn_total_rewards": "總獎勵 (MNT)",
  "lpn_trade": "交易",
  "lpn_trade_desc": "在現貨市場上買賣加密貨幣。",
  "lpn_trade_detail_entry": "交易量詳情",
  "lpn_trade_statistics_rule_tips": "快照結束日期（ {date1} 至 {date2} UTC）前 30 天內的所有現貨交易量都將計入現貨交易量要求。其中包括現貨交易、現貨槓桿交易、槓桿代幣交易，以及透過現貨網格機器人和定投機器人執行的交易。上述時間範圍內完成的所有買幣和賣幣交易都將納入計算。",
  "lpn_trade_volume_cover_enough": "您已達到參與代幣分配抽籤所需的日均持倉量。",
  "lpn_trade_volume_not_enough": "抱歉，您快照結束日期 ({date1} ~ {date2} (UTC) 前 30 天內的現貨交易量未能達到要求。使用計算器計算需要追加買入的金額。",
  "lpn_trade_volume_update_time": "您的現貨交易量將於 {date} 3:00 (UTC) 更新。",
  "lpn_trading_calculator_title": "日均交易量計算器",
  "lpn_trading_fail": "您當前的日均交易量未能達到要求。",
  "lpn_two_progress_info": "分派預期將完成於",
  "lpn_two_progress_title": "分配和抽獎進行中……",
  "lpn_unable_snapshot": "您的賬戶餘額未達到最低要求。請在下次快照期間進行符合條件的儲值或提升您的交易量。",
  "lpn_unsub_dialog_cancel": "取消",
  "lpn_unsub_dialog_confirm": "確認",
  "lpn_unsub_dialog_text": "您確定要取消訂閱嗎？取消訂閱後，您不會再收到關於上線活動、快照、申購和代幣分配結果的 Launchpad 通知。",
  "lpn_unsub_dialog_title": "注意",
  "lpn_up_to": "最高 120 MNT",
  "lpn_upgrade_to_vip": "升級為 VIP",
  "lpn_upgrade_to_vip_current_level": "當前等級",
  "lpn_upgrade_vip_btn_text": "VIP 升級",
  "lpn_upper_limit": "個人認購上限",
  "lpn_user_center": "用戶中心",
  "lpn_view_all": "查看所有項目",
  "lpn_view_details": "查看詳情",
  "lpn_vip_calculator_notice1": "如果您已按計算器建議的數額提高交易量，則無需額外交易量即可參與抽籤。您的最終交易量將於 {time} 3:30 (UTC) 更新。",
  "lpn_vip_calculator_notice2": "快照結束日期（ {date1} 至 {date2} UTC）前 30 天內的所有現貨交易量都將計入現貨交易量要求。其中包括現貨交易、現貨槓桿交易、槓桿代幣交易，以及透過現貨網格機器人和定投機器人執行的交易。上述時間範圍內完成的所有買幣和賣幣交易都將納入計算。請注意，衍生品交易的交易量不計入其中。您當天的綜合日均交易量將於次日 3:00 (UTC) 更新。",
  "lpn_vip_calculator_user_trading_vol": "您的交易量",
  "lpn_vip_card_desc": "交易量達到要求後，根據您的 VIP 等級，投入 {amount1} 到 {amount2} {currency}，即可獲得一張抽獎券，有機會贏取 {token}！中籤後，您將收到 {limitAmount1} 到 {limitAmount2} {token}，具體取決於您的已投代幣數額！",
  "lpn_vip_detail_card_login_tip": "登錄查看購買限額。",
  "lpn_vip_last_day_time": "* 必須在 {time} (UTC) 之前達到要求。",
  "lpn_vip_level_token_tip": "（每位中籤用戶可獲得 {amount} {token} ）",
  "lpn_vip_lottery_title": "要參與代幣分配抽籤，您必須達到現貨交易量要求。",
  "lpn_vip_not_join_account_tip": "由於賬戶限制，您不符合參與本活動的條件。本活動不面向機構用戶、機構用戶關聯用戶及託管用戶開放。",
  "lpn_vip_not_kyc_tip1": "正在計算您的最終交易量。",
  "lpn_vip_not_kyc_tip2": "您可在 {time} (UTC) 查看結果。",
  "lpn_vip_order_dialog_title": "投入 {amount1} {currency} 獲取抽獎券，中籤後可獲得 {amount2} 新代幣！",
  "lpn_vip_project_title": "投入 {token}，參與代幣分配抽籤。",
  "lpn_vip_trade_btn": "交易",
  "lpn_vip_trade_val_fail": "抱歉，您未能達到本次 Launchpad 的最低要求。請在下次 Launchpad 快照期結束前達到現貨交易量要求，或升級為 VIP 用戶。",
  "lpn_vip_user_need_trading_vol_tip": "根據最新快照結果，您需要額外交易<b>{amount} USDT</b>，才有資格參與抽籤活動。",
  "lpn_vip_volume_calculator": "交易量計算器",
  "lpn_win_benefits": "每位中獎者所獲分配額度",
  "lpn_win_prize": "每張中籤抽獎券的代幣分配額度",
  "lpn_your_card_purchase_limits": "您的購買數額",
  "lpSnapshotDescContent3": "在 {snapshot_days} 天快照期內，您資金賬戶、現貨賬戶及合約賬戶（或統一交易賬戶和反向合約賬戶）中所有幣種的日均持倉量將透過每小時資產快照進行記錄。當天的日均持倉量將於次日 3:00 (UTC) 更新。\n\n對於非 USDT 資產，持倉量將根據當天收盤價折算為 USDT。\n\n假設 Bob 在 10 月 28 日註冊了 Bybit 賬戶，並從 21:00 (UTC) 開始每小時為資金賬戶儲值 100 MNT。Bob 的每小時餘額快照記錄如下：21:00 (UTC) 100 MNT，22:00 (UTC) 200 MNT，23:00 (UTC) 300 MNT。因此，10 月 28 日 Bob 資金賬戶中的 MNT 日均持倉量將為 25 MNT。\n\n[(100 + 200 + 300) / 24] = 25\n\n假設 10 月 28 日 MNT/USDT 的收盤價為 1 USDT。10 月 29 日 3:00 (UTC) 之後，Bob 會看到他 10 月 28 日的日均持倉量更新為 25 USDT。\n\n25 * 1 = 25 USDT",
  "lpSnapshotDescTitle1Lottery": "How are my holdings calculated for MNT subscription or USDT lottery?",
  "lpSnapshotDescTitle3Lottery": "如何計算持倉量，以確定我是否有資格獲得 2 張或 3 張抽獎券？",
  "lpSnapshotTabTitle": "總持倉量快照",
  "lpSnapshotTradingTh": "總持倉量",
  "lpTickets": "抽獎券",
  "lpTrade": "交易",
  "lpTradeOrDeposit": "交易/儲值",
  "lpTransfer": "划轉",
  "MARKET": "市場價格",
  "max": "最大",
  "mntSubscriptionJoinedNotice": "您已參與 MNT 申購，因此您當前不能參與抽獎。",
  "more": "更多",
  "myBenefits": "我的權益",
  "mySnapshotData": "我的快照數據",
  "needAdditionalAmountForLottery": "您需要追加買入/儲值<b>{additional_amount} {currency}</b>，才符合抽獎參與資格。所顯示的USDT僅為您主帳戶中目前所持有的資產（資金帳戶， 現貨帳戶與衍生品帳戶/ 統一交易帳戶與反向衍生品帳戶）， 不包含子帳戶中的資產與質押於Bybit儲蓄中的資產。具體的快照邏輯請參考下面的詳細說明。",
  "network_error": "請求失敗，請稍後重試。",
  "NEW": "待成交",
  "next_page": "下一頁",
  "no_more_text": "沒有更多內容",
  "nodata": "暫無記錄",
  "none": "無",
  "nonUsdtAssetsConversion": "對於非 USDT 資產，持倉量將根據當天收盤價折算為 USDT。",
  "nonUsdtPairsTradingVolumeConversion": "對於非 USDT 計價的交易對，交易量將根據當天收盤價折算為 USDT。",
  "notCountedTradingVolume": "以下產品的交易量不計算在內。",
  "notice": "注：",
  "notIncludedTradingTypes": "所有現貨交易、現貨跟單交易、網格機器人、定投機器人、現貨槓桿交易、槓桿代幣和 API 交易的買賣均不計算在內。",
  "officalWebsite": "官網",
  "og_title": "{symbol} | 買賣交易，盡享低手續費 | Bybit 現貨",
  "ongoing": "進行中",
  "onGoing": "進行中",
  "operationSuccess": "成功",
  "or": "或",
  "orderAmount": "订单总额",
  "orderBook": "訂單表",
  "orderHistory": "訂單歷史",
  "orderId": "訂單單號",
  "orderType": "訂單類型",
  "otcErrorInfo": "抱歉，您開通了機構借貸，無法進行槓桿交易。",
  "outstanding": "待還",
  "pastPerformance": "已發售項目",
  "previous_page": "上一頁",
  "price": "價格",
  "quantity": "數量",
  "referAndEarn": "邀好友，賺獎勵",
  "referFriendsEarnToget": "邀請好友，共同賺幣！",
  "referralHistRules": "推薦記錄與規則",
  "registeredSuccessfully": "報名成功",
  "registerEventIdentityVerification": "您需要完成 1 級身份認證，才能報名參與本活動。",
  "registerNow": "立即報名",
  "registerToJoinLottery": "現在報名，隨後參與抽獎。",
  "registerToJoinSubscription": "現在報名，隨後參與申購。",
  "reset": "重設",
  "resultsAnnouncementTime": "結果公布倒計時",
  "resultsWillBeAnnounced": "結果公布倒計時",
  "reverse_contract_account": "反向合約賬戶",
  "riskWarning": "確認彈窗",
  "saleEndsIn": "發售結束倒計時",
  "saleEndsIn1": "發售結束倒計時",
  "saleInfo": "發售信息概覽",
  "saleStartsIn": "發售開始倒計時",
  "saleStartsIn1": "發售開始倒計時",
  "search": "搜尋",
  "secureEarlyAccess": "率先獲得 Bybit 明星項目的代幣！您可以使用 MNT 申購所發售代幣，或使用 USDT 參與代幣分配抽獎。您在資產快照期內持有的代幣數量將決定您可申購的代幣數量以及您在代幣分配抽獎中贏得代幣分配權的幾率。",
  "shareAndEarn": "分享賺幣",
  "sharePrizePool": "邀請好友參與活動，瓜分 {prizepool} {token} 獎池！",
  "shareToEarn": "分享賺幣",
  "side": "方向",
  "signup": "註冊",
  "snapshotBalancesCounted": "資產快照期間，哪些餘額會計算在內？",
  "snapshotPeriodRecord": "資產快照期間 ({time1} – {time2} UTC)，您資金賬戶、現貨賬戶及合約賬戶（或統一交易賬戶和反向合約賬戶）中的資產將透過每小時快照記錄。",
  "snapshotPeriodTradingVolumeRecord": "{x} 天快照期間，以下產品的累計交易量總和將透過每日快照記錄。",
  "snapshotPeriodVolumeRecord": "<p>3. 快照期內，現貨交易、現貨跟單交易、網格機器人、定投機器人、現貨槓桿交易和槓桿代幣的綜合累計交易量將透過每日快照進行記錄，其中包括所有買賣交易。對於以 USDT 計價的交易對，交易量為所有已成交 USDT 訂單的訂單價值之和。對於非 USDT 計價的交易對，交易量將根據當天收盤價折算為 USDT。請注意，透過 API 交易、衍生品交易、跟單交易 Pro 以及 0 手續費交易對產生的交易量不會計入活動。</p>",
  "snapshotResultsPeriodUtc": "資產快照期 {time1} – {time2} (UTC) 快照結果如下：",
  "snapshotsRules": "快照規則",
  "spot_account": "現貨賬戶",
  "spotAccount": "現貨賬戶",
  "spotCopyTrading": "現貨跟單交易",
  "spotMarginTrading": "現貨槓桿交易",
  "spotTrading": "現貨交易",
  "spotTradingReqCalculationQualification": "要判斷我有資格獲得 2 張還是 3 張抽獎券，現貨交易量要求是如何計算的？",
  "spotTradingVolCopyTrdPro": "跟單交易 Pro 產生的現貨交易量",
  "spotTradingVolume200Usdt": "現貨交易量：200 USDT",
  "spotTradingVolume300Usdt": "現貨交易量：300 USDT",
  "spotTradingVolumeUsdt": "現貨交易量：100 USDT",
  "spotTradingVolumeZeroFees": "0 手續費現貨交易對產生的交易量",
  "status": "狀態",
  "step": "Step",
  "stop_limit": "止盈止損",
  "stop_limit_tips_2": "當前有止盈止損委託單，暫不支持開啟槓桿交易。",
  "subBtnText": "訂閱",
  "subscribeOrJoinLottery": "投入 MNT，參與申購；或投入 USDT，參與抽獎",
  "subscribeToBuyTokenWithCurrency": "投入 {currency}，申購 {token}",
  "subscribeTokenWithAvgBal": "日均持倉量至少達到 {minPledgeAmount} {currency}，即可申購 {token} 分配。",
  "subscriptionEligibilityConfirmation": "恭喜！您符合申購參與資格。",
  "subscriptionEligibilityInfo": "如果您已按建議追加買入/儲值 {currency}，且未提幣或賣幣，則符合申購參與資格，無需再次買入/儲值。您的最終日均持倉量將於 {time} 3:30 (UTC) 更新。",
  "subscriptionHoldingsError": "抱歉！您的日均持倉量未達到參與申購的最低資格要求，因此您不能參與申購。下次 Launchpad 請確保 {currency} 儲值數額達到要求。",
  "subscriptionPeriodCalc": "如何計算申購期內的最終代幣分配數量？",
  "subToastSuccess": "訂閱成功",
  "success": "成功",
  "sure": "sure",
  "theTokenSaleHasAlreadyEnded": "代幣發售已結束。",
  "times": "次",
  "timestamp": "時間",
  "title_404": "404 {'|'} Bybit 貨交易  ",
  "title_exchange": "{close} {'|'} {symbols} {'|'} Bybit 貨交易 ",
  "to": "至",
  "toastTheSymbolNotExist": "抱歉！您選擇的交易對暫無法訪問",
  "tokenLaunchpadUpdateNotice": "很抱歉，您當前持倉量不符合 {{TOKEN_NAME}} Launchpad 參與要求。點此瞭解詳情 👉",
  "tokenSale": "首次代幣發售",
  "tokenSaleEligibilityError": "您未在 {time1} – {time2} (UTC) 參與活動，因此不能獲得代幣分配。",
  "tokenSaleRecords": "代幣發售記錄",
  "tokenSaleSubscriptionError": "您已選擇投入 USDT 參與抽獎，因此不能投入 MNT 參與申購。",
  "total": "累計",
  "totalSupply": "發行總量",
  "tradingPairs": "現貨交易對",
  "tradingVolume": "交易量",
  "transactionRecords": "其中包括您所有的買入和賣出交易。",
  "transfer": "劃轉",
  "transferableBalanceNotEnough": "划轉失敗，可用餘額不足。",
  "turnover": "成交額",
  "unifiedTradingAccount": "統一交易賬戶",
  "unsubBtnText": "退訂",
  "unsubToastSuccess": "退訂成功",
  "updateDailyAvgMntHoldings": "用戶 2 月 23 日的 MNT 日均持倉量將於 2 月 24 日 3:00 (UTC) 後更新為 25 MNT。",
  "updateDailyHoldingsFeb23": "假設 MNT/USDT 收盤價為 1 USDT，用戶 2 月 23 日的日均持倉量將於 2 月 24 日 3:00 (UTC) 後更新為 25 USDT。",
  "updateTradeVolumeFeb23": "用戶 2 月 23 日的每日累計交易量將於 2 月 24 日 3:00 (UTC) 後更新為 600 USDT。",
  "updateUsdtHoldingsFeb23": "用戶 2 月 23 日的 USDT 日均持倉量將於 2 月 24 日 3:00 (UTC) 後更新為 25 USDT。",
  "usdc_contract_account": "USDC 合約賬戶",
  "usdtHoldings": "USDT 持倉量",
  "usdtPairsTradingVolumeSum": "對於以 USDT 計價的交易對，交易量為所有已成交 USDT 訂單的訂單價值之和。",
  "viewDetails": "瞭解詳情",
  "volume": "已成交量",
  "walletBalanceInUsdt": "錢包餘額：100 USDT",
  "walletBalanceMnt100": "錢包餘額：100 MNT",
  "walletBalanceMnt200": "錢包餘額：200 MNT",
  "walletBalanceMnt300": "錢包餘額：300 MNT",
  "walletBalanceUsdt200": "錢包餘額：200 USDT",
  "walletBalanceUsdt300": "錢包餘額：300 USDT",
  "whiteBook": "白皮書",
  "whoIsEligible": "哪些用戶符合 Launchpad 參與資格？",
  "winningNumber": "中籤號碼："
}